<template>
        <v-layout row class="text-xs-center">
            <v-flex xs10 fluid id="minimap_container"></v-flex>
        </v-layout>
</template>

<script>
/* import other components here */
export default {
	data() {
		return {}
	},
	methods: {}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Minimap.vue